<template>
  <div>
    <div v-wechat-title="language.title"></div>

    <section>
      <div id="top">
        <div class="top-left">
          <div style="position: relative; height: 45px;">
            <div class="user-image">
              <img :src="data.avatar || ''" alt="" />
            </div>
            <div class="user-name">
              {{ data.name }}
            </div>
          </div>
          <div>
            <div class="info-list">
              <div class="info-label">
                <div class="label-img">
                  <img src="../assets/images/newreport/dingwei.png" />
                </div>
                <div class="label-text">
                  {{ data.city }}
                </div>
              </div>
              <div class="clear"></div>
              <div class="info-label">
                <div class="label-img">
                  <img src="../assets/images/newreport/qingtian.png" />
                </div>
                <div class="label-text">
                  {{ data.weather }} {{ data.temp }}°
                </div>
              </div>
              <div class="clear"></div>
              <div class="info-label">
                <div class="label-img">
                  <img src="../assets/images/newreport/huazuangshu.png" />
                </div>
                <div class="label-text">
                  {{ data.beauty_title }}
                </div>
              </div>
              <div class="clear"></div>
            </div>
          </div>
        </div>
        <div class="top-right">
          <div class="right-age" v-if="data.age">
            <div class="age">
              <div class="age-number">
                {{ data.age }}
              </div>
            </div>
            <p>{{ language.skinAge }}</p>
          </div>
          <div class="right-age" v-else>
            <div class="age2">
              <img :src="data.weather_pic" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="section-label">
        <div class="section-label-img">
          <img src="../assets/images/newreport/label.jpg" />
        </div>
        <div class="section-label-title">{{ language.comprehensive }}</div>
      </div>
      <div id="skinRadar" :style="{ width: '350px', height: '350px' }"></div>
      <div class="tend-level">
        <div class="tend-level-item">{{ language.careLevel }}:</div>
        <div class="tend-level-item">
          <div class="color-item level1"></div>
          {{ language.level1 }}
        </div>
        <div class="tend-level-item">
          <div class="color-item level2"></div>
          {{ language.level2 }}
        </div>
        <div class="tend-level-item">
          <div class="color-item level3"></div>
          {{ language.level3 }}
        </div>
        <div class="tend-level-item">
          <div class="color-item level4"></div>
          {{ language.level4 }}
        </div>
      </div>
      <div class="level_banner">
        <div class="level-left">{{ language.needNow }}</div>
        <div class="level-right">{{ data.urgentNursing }}</div>
      </div>
    </section>

    <!-- 中间 -->
    <!--  -->
    <section class="section">
      <div class="section-label">
        <div class="section-label-img">
          <img src="../assets/images/newreport/label.jpg" />
        </div>
        <div class="section-label-title">{{ language.multOption }}</div>
      </div>
      <div id="myBarLine" :style="{ width: '360px', height: '360px' }"></div>
    </section>

    <!-- 肤质分析 -->
    <section class="section" v-if="skin !== 0">
      <div class="section-label">
        <div class="section-label-img">
          <img src="../assets/images/newreport/label.jpg" />
        </div>
        <div class="section-label-title">{{ language.skinAnalysis }}</div>
      </div>
      <img :src="skinSrc" style="width: 100%;" alt="" />
    </section>

    <section class="section" v-if="data.colour > 0">
      <div class="section-label">
        <div class="section-label-img">
          <img src="../assets/images/newreport/label.jpg" />
        </div>
        <div class="section-label-title">{{ language.skinColorAnalysis }}</div>
      </div>
      <div class="color-skin">
        <div
          class="color-skin-item"
          v-for="item of skinColorArray"
          :key="item.id"
        >
          <div :class="item.colorStyle"></div>
          <div :class="item.nameStyle">{{ item.title }}</div>
          <div class="skin-color-selected" v-if="item.state == 1"></div>
        </div>
      </div>
    </section>

    <!-- 采样图 -->
    <section class="section" v-if="data.sampling && data.sampling.length">
      <div class="section-label">
        <div class="section-label-img">
          <img src="../assets/images/newreport/label.jpg" />
        </div>
        <div class="section-label-title">{{ language.sampling }}</div>
      </div>

      <div class="skin-image">
        <div class="skin-image-line">
          <div
            class="skin-image-item"
            v-for="item of data.samplingMap1"
            :key="item.id"
          >
            <div class="skin-image-item-img">
              <img :src="item.url || ''" alt="" />
            </div>
            <div class="skin-image-item-text">
              {{ item.name }}
            </div>
          </div>
        </div>

        <div class="skin-image-line">
          <div
            class="skin-image-item"
            v-for="item of data.samplingMap2"
            :key="item.id"
          >
            <div class="skin-image-item-img">
              <img :src="item.url || ''" alt="" />
            </div>
            <div class="skin-image-item-text">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 中间 -->
    <section class="section" v-if="data.skinCondition">
      <div class="section-label">
        <div class="section-label-img">
          <img src="../assets/images/newreport/label.jpg" />
        </div>
        <div class="section-label-title">{{ language.condition }}</div>
      </div>

      <div class="analayse" v-for="item of data.skinCondition" :key="item.id">
        <div class="analayse-title">
          <img src="../assets/images/newreport/spec.jpg" alt="" />
          {{ item.items }}
          <img src="../assets/images/newreport/spec.jpg" alt="" />
        </div>
        <div class="quetion-item" v-if="item.intro">
          <div class="quetion-title">{{ language.cause }}：</div>
          <div class="quetion-content">
            <p>{{ item.intro }}</p>
          </div>
        </div>
        <div class="quetion-item" v-if="item.experts">
          <div class="quetion-title">{{ language.tips }}：</div>
          <div class="quetion-content">
            <p>{{ item.experts }}</p>
          </div>
        </div>
        <div class="quetion-item" v-if="item.suggest">
          <div class="quetion-title">{{ language.suggest }}：</div>
          <div class="quetion-content">
            <p>{{ item.suggest }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 中间 -->
    <section
      class="section"
      v-if="data.goods !== undefined && data.goods.length > 0"
    >
      <div class="section-label">
        <div class="section-label-img">
          <img src="../assets/images/newreport/label.jpg" />
        </div>
        <div class="section-label-title">{{ language.productRecommend }}</div>
      </div>
      <div v-for="item of data.goods" :key="item.id">
        <div class="product-img" v-if="item.images">
          <a :href="item.url"><img :src="item.images || ''" alt="" /></a>
        </div>
        <div class="product-title">
          <a :href="item.url">{{ item.name }}</a>
        </div>
      </div>
    </section>

    <section class="section" v-if="false == true">
      <div class="section-label">
        <div class="section-label-img">
          <img src="../assets/images/newreport/label.jpg" />
        </div>
        <div class="section-label-title">报告反馈</div>
      </div>

      <p style="font-size: 1rem; margin-top: 15px;">
        您对本次报告满意吗？ 给个评价呗！
      </p>
      <div class="start-list">
        <div class="start-item" v-for="i in 5" :key="i" @click="changeStar(i)">
          <img :src="startSrc[i]" alt="" />
        </div>
      </div>

      <div class="assess">
        <textarea
          name=""
          id="assess-input"
          cols="30"
          rows="5"
          v-model="language.placeholder"
        >
...</textarea
        >
      </div>
      <p
        style="
          color: #9c9b9b;
          text-align: right;
          font-size: 0.8rem;
          margin: 5px 5px 0 0;
        "
      >
        {{ language.supl }}
      </p>
      <div class="submit-btn">
        <button>{{ language.submitBtn }}</button>
      </div>
    </section>
  </div>
</template>
<style lang="stylus">
html, body {
  padding: 0;
  margin: 0;
  background: #efefef;
}

section {
  margin-bottom: 20px;
  background: #FFF;
}

#top {
  background-image: url('../assets/images/newreport/top-backgroup.jpg');
  padding: 10px 18px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
}

.top-left {
  flex-grow: 1;
}

.top-right {
  flex-grow: 1;
}

.user-image {
  width: 45px;
  position: absolute;
  z-index: 1;
}

.user-image img {
  width: 100%;
  border-radius: 50px;
}

.user-name {
  position: absolute;
  background: rgba(255, 255, 255, 0.5);
  top: 20px;
  left: 10px;
  padding: 0px 20px;
  padding-left: 45px;
  border-radius: 15px;
  font-size: 0.7rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 150px;
  height: 25px;
  line-height: 25px;
  color: #FFF;
}

.info-list {
  position: relative;
  height: 80px;
  margin-top: 25px;
  margin-bottom: 20px;
}

.label-img img {
  width: 15px;
  margin-top: 3px;
}

.label-img {
  float: left;
  margin-right: 10px;
  color: #FFF;
  font-size: 0.7rem;
  line-height: 20px;
  height: 20px;
}

.label-text {
  color: #FFF;
  font-size: 0.7rem;
  line-height: 20px;
  padding-right: 15px;
  float: left;
}

.info-label {
  display: inline-block;
  padding: 1px 10px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 25px;
  margin-top: 2px;
}

.clear {
  clear: both;
}

.age {
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  background: rgba(255, 255, 255, 0.4);
  color: #FFF;
  position: relative;
  border-radius: 80px;
  margin: 0 auto;
  margin-top: 40px;
  margin-bottom: 12px;
}

.age2 {
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  color: #FFF;
  position: relative;
  border-radius: 80px;
  margin: 0 auto;
  margin-top: 40px;
  margin-bottom: 12px;
}

.age-number {
  position: absolute;
  width: 60px;
  height: 60px;
  left: 10px;
  top: 10px;
  line-height: 60px;
  text-align: center;
  background: rgba(255, 255, 255, 1);
  color: #fb26f2;
  font-size: 1.5rem;
  border-radius: 60px;
}

.right-age p {
  text-align: center;
  color: #FFF;
}

.section {
  padding: 10px;
}

.section-label {
  display: flex;
  height: 40px;
}

.section-label-img img {
  width: 15px;
}

.section-label-img {
  flex-grow: 1;
}

.section-label-title {
  flex-grow: 20;
  height: 40px;
  line-height: 40px;
  font-size: 1.3rem;
}

/* 皮肤综合检测 */
.tend-level {
  display: flex;
  margin-bottom: 30px;
}

.tend-level-item {
  flex-grow: 1;
  font-size: 0.8rem;
  color: #828282;
}

.color-item {
  display: inline-block;
  width: 10px;
  height: 10px;
  border: 1px solid red;
}

.level1 {
  background: #f2a1a1;
  border: 1px solid #f2a1a1;
}

.level2 {
  background: #f8eb99;
  border: 1px solid #f8eb99;
}

.level3 {
  background: #a1d4fc;
  border: 1px solid #a1d4fc;
}

.level4 {
  background: #c3f7d2;
  border: 1px solid #c3f7d2;
}

.level_banner {
  display: flex;
  margin-bottom: 20px;
  margin-top: 15px;
}

.level-left {
  flex-grow: 2;
  text-align: center;
  background-image: url('../assets/images/newreport/level_banner1.jpg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 45px;
  line-height: 45px;
  color: #FFF;
  font-size: 1.1rem;
}

.level-right {
  flex-grow: 3;
  background-image: url('../assets/images/newreport/level_banner2.jpg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 45px;
  line-height: 45px;
  text-align: center;
  font-size: 1.1rem;
}

.color-skin {
  margin-top: 20px;
  display: flex;
}

.color-skin-item {
  flex-grow: 1;
  padding: 3px;
}

.skin-color-block {
  height: 30px;
}

.skin-color-level1 {
  background-color: #ffeede;
}

.skin-color-level2 {
  background-color: #feddcc;
}

.skin-color-level3 {
  background-color: #edcda7;
}

.skin-color-level4 {
  background-color: #cc9988;
}

.skin-color-level5 {
  background-color: #997754;
}

.skin-color-level6 {
  background-color: #644445;
}

.skin-color-text {
  text-align: center;
  margin-top: 10px;
  font-size: 0.7rem;
  color: #828282;
}

.selected {
  color: #fb26f2;
}

.skin-color-selected {
  width: 15px;
  height: 12px;
  background-image: url('../assets/images/newreport/skin-selected.jpg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin: 0 auto;
  margin-top: 10px;
}

.skin-image {
  margin-top: 15px;
}

.skin-image-line {
  display: flex;
}

.skin-image-item {
  flex-grow: 1;
  padding: 7px;
}

.skin-image-item-img {
  margin-bottom: 5px;
}

.skin-image-item-img img {
  width: 100%;
}

.skin-image-item-text {
  font-size: 0.6rem;
  text-align: center;
}

.quetion-item {
  margin-bottom: 10px;
}

.quetion-title {
  font-size: 0.8rem;
  font-weight: bold;
}

.quetion-content {
  font-size: 0.7rem;
  color: #828282;
}

.quetion-content p {
  margin-top: 5px;
  line-height: 21px;
}

.analayse {
  margin-top: 20px;
  margin-bottom: 30px;
}

.analayse-title {
  text-align: center;
  margin-bottom: 10px;
  color: #ff3f3f;
  font-size: 1rem;
}

.analayse-title img {
  width: 100px;
}

.product-img {
  margin-top: 20px;
}

.product-img img {
  display: block;
  width: 100%;
  margin: 0 auto;
}

.product-title {
  width: 70%;
  text-align: center;
  margin: 0 auto;
  margin-top: 10px;
  font-size: 0.9rem;
  color: #828282;
  line-height: 1.2rem;
}

.start-list {
  display: flex;
  width: 70%;
  margin: 0 auto;
  margin-top: 18px;
}

.start-item {
  flex-grow: 1;
  text-align: center;
}

.start-item img {
  width: 30px;
}

.assess {
  width: 100%;
  margin: 0 auto;
}

.assess textarea {
  display: block;
  border-radius: 6px;
  resize: none;
  outline: none;
  width: 95%;
  margin: 0 auto;
  margin-top: 15px;
  padding: 10px 15px;
  font-size: 1rem;
  border-color: #dedede;
}

.submit-btn button {
  display: block;
  background-image: url('../assets/images/newreport/submit-btn.png');
  background-size: 100% 100%;
  background-color: none;
  border-radius: 50px;
  border: none;
  width: 80%;
  height: 50px;
  margin: 30px auto;
  color: #FFF;
  outline: none;
  box-shadow: 0px 10px 30px rgba(251, 38, 242, 0.4);
}

#skinRadar {
  margin: 0 auto;
}

#myBarLine {
  margin: 0 auto;
}
</style>

<script>
// 引入基本模板
let echarts = require("echarts/lib/echarts");
// 雷达图
require("echarts/lib/chart/radar");
// 引入柱状图组件
require("echarts/lib/chart/bar");
require("echarts/lib/chart/line");
// 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");

export default {
  name: "NewWXReport",
  data() {
    return {
      data: {},
      age: 0,
      name: "",
      timer: undefined,
      showMask: true,
      showPersonNum: true,
      maskPath: require("../assets/images/report/mask.png"),
      personNum: 0,
      isShowPersonNum: false,
      id: 0,
      sign: "",
      tmpKey: "",
      bgPaths: [],
      iconPaths: [],
      verbPaths: {},
      titlePKPaths: [],
      titleTestPaths: [],
      bottomBottonBgPath: [],
      bottomBottonBgDownPath: [],
      colour: "", // 肤色
      water: "", // 含水量
      oil: "", // 含油量
      skin:0,
      skinSrc: "", // 饼图 图片
      skinColorArray: [], // 肤色分析
      goods: [], // 商品列表
      samplingMap: [], // 采样图
      startSrc: [], // 星星
      language: {},
    };
  },
  mounted() {},
  computed: {
    styleType() {
      switch (this.data.weathertype) {
        case 1:
        case 17:
          return 1;
        case 2:
        case 10:
        case 11:
        case 12:
        case 13:
        case 14:
        case 15:
        case 16:
          return 2;
        default:
          return 3;
      }
    },
    UVLevel() {
      return (
        [undefined, "0-2 最弱", "3-4 弱", "5-6 中等", "7-9 强", "10+ 最强"][
          this.data.uv - 1
        ] || "未知"
      );
    },
  },
  async created() {
    const wx = require("weixin-js-sdk");
    this.$nextTick(() => {
      for (let i = 1; i <= 17; i++) {
        this.bgPaths.push(
          require(`../assets/images/weather/weather-bg-${i}.gif`)
        );
        this.iconPaths.push(
          require(`../assets/images/weather-icon/weather-icon-${i}.png`)
        );
      }

      for (let i = 1; i <= 7; i++) {
        for (let j = 1; j <= 4; j++) {
          this.$set(
            this.verbPaths,
            String(i) + "-" + String(j),
            require(`../assets/images/feature/face/${i}-${j}.png`)
          );
        }
      }

      for (let i = 1; i <= 3; i++) {
        this.titlePKPaths.push(
          require(`../assets/images/report/title-pk-${i}.png`)
        );
        this.titleTestPaths.push(
          require(`../assets/images/report/title-test-${i}.png`)
        );
        this.bottomBottonBgPath.push(
          require(`../assets/images/report/bottom-button-${i}.png`)
        );
        this.bottomBottonBgDownPath.push(
          require(`../assets/images/report/bottom-button-${i}-down.png`)
        );
      }
    });
    this.id = this.$route.query.id;
    this.sign = this.$route.query.sign;

    // https://data.wax-apple.cn/Index/Report/Pifu_play?id=315558&sign=5a8bbbd84b2fec7879a2a14f5b15312b
    let latitude;
    let longitude;
    try {
      const { appId, timestamp, noncestr, signature } = (
        await this.$axios.get("/Index/Report/GetWechatConfig", {
          params: {
            checkid: this.id,
            sign: this.sign,
          },
        })
      ).data.data[0];
      await new Promise((resolve, reject) => {
        wx.config({
          appId,
          timestamp,
          nonceStr: noncestr,
          signature,
          jsApiList: ["getLocation"],
        });
        wx.ready(() => {
          wx.getLocation({
            type: "gcj02",
            success(res) {
              latitude = res.latitude;
              longitude = res.longitude;
            },
            complete() {
              resolve();
            },
          });
        });
        setTimeout(() => {
          resolve();
        }, 1000);
      });
    } catch (err) {
    } finally {
      const params =
        latitude && longitude
          ? {
              id: this.id,
              sign: this.sign,
              latitude,
              longitude,
            }
          : {
              id: this.id,
              sign: this.sign,
            };
      // const response = await this.$axios.get('/Index/Report/Pifu_play', {
      //   params
      // })
      const languagePack = [];
      const chinese = {
        skinAge: "肌肤年龄",
        comprehensive: "皮肤综合分析",
        needNow: "急需护理项",
        multOption: "各项对比分析图",
        sampling: "采样图",
        condition: "皮肤状况分析",
        cause: "成因分析",
        tips: "专家提示",
        suggest: "护理建议",
        level1: "急救修复",
        level2: "深度护理",
        level3: "中级护理",
        level4: "初级护理",
        careLevel: "护理等级",
        submitBtn: "提交反馈",
        placeholder: "请再次输入您的评价",
        surp: "还可以输入100个字",
        title: "检测报告",
        lineName: "● 大数据对比",
        lineXName: "较差",
        lineYName: "优质",
        lineSeriesNow: "当前检测值",
        lineSeriesAverage: "大数据平均值",
        skinAnalysis: "肤质分析",
        skinColorAnalysis: "肤色分析",
        productRecommend: "产品推荐",
      };

      const tranditional = {
        skinAge: "肌膚年齡",
        comprehensive: "皮膚綜合分析",
        needNow: "急需護理項",
        nultOption: "各項對比分析圖",
        sampling: "采樣圖",
        condition: "皮膚狀況分析",
        cause: "成因分析",
        tips: "專家提示",
        suggest: "護理建議",
        level1: "急救修復",
        level2: "深度護理",
        level3: "中度護理",
        level4: "初級護理",
        careLevel: "護理等級",
        submitBtn: "提交反饋",
        placeholder: "請再次輸入您的評價",
        surp: "還可以輸入100個字",
        title: "檢測報告",
        lineName: "● 大數據對比",
        lineXName: "較差",
        lineYName: "優質",
        lineSeriesNow: "當前檢測值",
        lineSeriesAverage: "大數據平均值",
        skinAnalysis: "膚質分析",
        skinColorAnalysis: "膚色分析",
        productRecommend: "產品推薦",
      };

      const english = {
        skinAge: "skin age",
        comprehensive: "skin comprehensive analysis",
        needNow: "care options",
        multOption: "Multiple Response",
        sampling: "Samping",
        condition: "Skin Condition Analysis",
        cause: "analysis of causes",
        tips: "tip guys",
        suggest: "nurse suggest",
        level1: "Emergency",
        level2: "Deep",
        level3: "Moderate",
        level4: "Primary",
        careLevel: "Level of care",
        submitBtn: "Submit Feedback",
        placeholder: "Please tell me your appraise",
        surp: "You can also type 100 words",
        title: "Test Report",
        lineName: "● Big Data",
        lineXName: "Poor",
        lineYName: "excellent",
        lineSeriesNow: "Current detection value",
        lineSeriesAverage: "Average Value of Big Data",
        skinAnalysis: "Skin Analysis",
        skinColorAnalysis: "Skin color analysis",
        productRecommend: "Product Recommend",
      };
      languagePack[1] = chinese;
      languagePack[2] = tranditional;
      languagePack[3] = english;
      const detailData = await this.$axios.get("/Index/Report/pifu_profes", {
        params,
      });
      // 暂时注释
      // detailData.data.datalist.forEach(x => (x.pertenlist = x.pertenlist.sort((vala, valb) => valb.name.localeCompare(vala.name))))
      this.data.detailData = detailData.data;
      this.data.avatar = this.data.detailData.avatar;
      this.data.city = this.data.detailData.weather.weather_area;
      this.data.age = this.data.detailData.age;
      this.data.name = this.data.detailData.name;
      this.data.weather = this.data.detailData.weather.weather;
      this.data.temp = this.data.detailData.weather.weather_temperature;
      this.data.colour = this.data.detailData.colour; // 肤色
      this.data.goods = this.data.detailData.goods;
      this.data.sampling = this.data.detailData.sampling;
      this.data.samplingMap1 = this.data.detailData.sampling.slice(0, 5);
      this.data.samplingMap2 = this.data.detailData.sampling.slice(5, 10);
      this.data.lineValue = [0, 0, 0, 0, 0, 0, 0];
      this.data.beauty_title = this.data.detailData.weather.beauty_title;
      this.data.weather_pic = this.data.detailData.weather.weather_pic;
      this.language = languagePack[detailData.data.language]; // 设置页面语言
      this.data.languageOpt = detailData.data.language;
      const lineindicator = [];
      const lineValue = [];
      const barLineText = [];
      const cloubNumber = [];
      const currentValue = [];
      const urgentNursingArray = detailData.data.datalist; // 急需护理项原数组
      var urgentNursing = ""; // 急需护理项
      const skinCondition = []; // 皮肤状况
      const barColorText = []; // 柱状图颜色
      // 饼图数据
      var water = "";
      var oil = "";
      var radarText = "";
      var barColor = "";

      this.data.detailData.datalist.forEach(function (x) {
        // 雷达图数据
        if (x.sort === 0) {
          radarText = 0;
          barColor = "rgb(195,247,210)";
        } else if (x.sort === 1) {
          radarText = 100;
          barColor = "rgb(195,247,210)";
        } else if (x.sort === 2) {
          radarText = 75;
          barColor = "rgb(161,212,252)";
        } else if (x.sort === 3) {
          radarText = 50;
          barColor = "rgb(248,235,153)";
        } else if (x.sort === 4) {
          radarText = 25;
          barColor = "rgb(242,161,161)";
        }
        barColorText.push(barColor); // 柱状图颜色
        lineValue.push(radarText); // 雷达图数据
        lineindicator.push({ text: x.items, max: 100 }); // 雷达图名称

        // 饼图数据
        if (x.id === "1") {
          water = x.value;
        }
        if (x.id === "2") {
          oil = x.value;
        }

        barLineText.push(x.items);
        cloubNumber.push(x.cloudvalue);
        currentValue.push(x.value);
        // 皮肤状况分析
        if (x.items !== "" && (x.intro || x.experts || x.suggest)) {
          skinCondition.push({
            items: x.items,
            intro: x.intro,
            experts: x.experts,
            suggest: x.suggest,
          });
        }
      });
      this.data.detailData.lineindicator = lineindicator;
      this.data.barColorText = barColorText;
      this.data.lineValue = lineValue;
      this.data.barLineText = barLineText;
      this.data.cloubNumber = cloubNumber;
      this.data.currentValue = currentValue;
      this.data.water = water;
      this.data.oil = oil;
      this.data.skinCondition = skinCondition; // 皮肤状况分析
      this.skin = this.data.detailData.skin;
      this.drawLine(); // 雷达图
      this.drawLine2(); // 线柱图
      this.skinAnalysis(); // 肤质分析
      this.skinColor(); // 肤色分析
      this.changeStar(0); // 星星评分

      urgentNursing = urgentNursingArray.sort(function (a, b) {
        if (a.value > 0 && b.value > 0) {
          return a.value > b.value;
        }
      });

      /* this.data.urgentNursing =
        urgentNursing[0].items + '、' + urgentNursing[1].items */

      this.data.urgentNursing = detailData.data.worstitems;
    }
    // 报告信息
    // this.timer = setInterval(async () => {
    //   const personData = await this.$axios.get('/Index/Report/OnlineNumber', {
    //     params: {
    //       sign: this.sign,
    //       checkid: this.id
    //     }
    //   })
    //   let {add, value} = personData.data.data[0]
    //   this.personNum = value
    //   // add += 1 // test
    //   if (add > 0) {
    //     const dom = document.querySelector('.person-number')
    //     const heartdom = document.createElement('span')
    //     heartdom.innerText = '+' + add
    //     heartdom.classList.add('heart')
    //     dom.appendChild(heartdom)
    //     setTimeout(() => dom.removeChild(heartdom), 3000)
    //   }
    // }, 30000)
  },
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let skinRadar = echarts.init(document.getElementById("skinRadar"));
      // 绘制图表
      skinRadar.setOption({
        title: {
          // text: '清单费用构成',
          textStyle: {
            fontWeight: "normal",
            fontSize: "14",
            color: "#666",
          },
          x: "center",
          y: "15",
        },
        // tooltip: {
        //   trigger: 'item'
        // },
        polar: [
          {
            radius: 95, // 半径
            center: ["50%", "50%"], // 图的位置
            splitNumber: 4,
            name: {
              // show: true, // 是否文字
              // formatter: null, // 文字的显示形式
              textStyle: {
                // show: true,
                color: "#FFF", // 文字颜色
              },
            },
            indicator: this.data.detailData.lineindicator,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#272727",
                width: 1,
                type: "solid",
              },
            },
            splitLine: {
              show: false,
              lineStyle: {
                width: 1,
                color: "#FFFFFF", // 图表背景网格线的颜色
              },
            },
            splitArea: {
              show: true,
              areaStyle: {
                color: [
                  "rgb(242,161,161)",
                  "rgb(248,235,153)",
                  "rgb(161,212,252)",
                  "rgb(195,247,210)",
                ], // 图表背景网格区域的颜色
              },
            },
          },
        ],
        calculable: true,
        series: [
          {
            name: "",
            type: "radar",
            symbol: "emptyCircle" /* 曲线圆点 */,
            symbolSize: 4,
            data: [
              {
                value: this.data.lineValue,
                name: "皮肤检测",
                totalNumber: 1000,
                itemStyle: {
                  normal: {
                    color: "rgb(128,105,245)", // 图表中各个图区域的边框线颜色
                  },
                },
              },
            ],
          },
        ],
      });
    },
    drawLine2() {
      // 基于准备好的dom，初始化echarts实例
      let myBarLine = echarts.init(document.getElementById("myBarLine"));
      let barColorText = this.data.barColorText;
      // 绘制图表
      myBarLine.setOption({
        tooltip: {
          trigger: "axis",
        },
        toolbox: {
          show: true,
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ["line", "bar"] },
            restore: { show: true },
            saveAsImage: { show: true },
          },
        },
        xAxis: [
          {
            name: this.language.lineXName,
            nameLocation: "start",
            nameTextStyle: {
              color: "#272727",
              padding: [40, -10, 0, 0],
            },
            type: "category",
            position: "bottom",
            boundaryGap: true,
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              interval: "auto",
              margin: 8,
              formatter: function (value) {
                return value.split("").join("\n");
              },
              textStyle: {
                color: "#272727",
                fontFamily: "sans-serif",
                fontSize: 8,
              },
            },
            splitLine: {
              show: false,
            },
            splitArea: {
              show: false,
            },
            data: this.data.barLineText,
          },
        ],
        yAxis: [
          {
            name: this.language.lineYName,
            type: "value",
            nameTextStyle: {
              color: "#272727",
              padding: [0, 25, 0, 0],
            },
            position: "left",
            min: 0,
            max: 100,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#ccc",
                width: 1,
              },
            },
            axisLabel: {
              show: true,
              interval: "auto",
              margin: 5,
              formatter: "{value}",
              textStyle: {
                color: "#272727",
                fontFamily: "verdana",
                fontSize: 10,
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#ccc",
                type: "dotted",
                width: 1,
              },
            },
          },
          {
            name: this.language.lineName,
            type: "value",
            nameTextStyle: {
              color: "rgb(158, 89, 244)",
              padding: [0, 50, 10, 0],
            },
            show: true,
            min: "0",
            max: "100",
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: this.language.lineSeriesNow,
            type: "bar",
            barWidth: 10, // 柱图宽度
            itemStyle: {
              normal: {
                label: {
                  show: true, // 开启显示
                  position: "top", // 在上方显示
                  textStyle: {
                    // 数值样式
                    color: "black",
                    fontSize: 10,
                  },
                },
                color: function (params) {
                  var colorList = barColorText;
                  return colorList[params.dataIndex];
                },
              },
            },
            data: this.data.currentValue,
          },
          {
            name: this.language.lineSeriesAverage,
            type: "line",
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                label: {
                  show: true, // 开启显示
                  position: "right",
                  textStyle: {
                    // 数值样式
                    color: "rgb(158, 89, 244)",
                    fontSize: 10,
                  },
                },
                color: "rgb(158, 89, 244)", // 图表中各个图区域的边框线颜色
              },
            },
            data: this.data.cloubNumber,
          },
        ],
      });
    },
    // 肤质分析
    skinAnalysis() {
      var water = this.data.water; // 水
      var oil = this.data.oil; // 油
      var skinState = 1; // 肤质状态

      if (water < 45) {
        if (oil < 45) {
          skinState = 1;
        } else if (oil >= 45 && oil < 50) {
          skinState = 1;
        } else if (oil >= 50 && oil < 55) {
          skinState = 1;
        } else if (oil >= 55 && oil < 60) {
          skinState = 1;
        } else if (oil >= 60) {
          skinState = 1;
        }
      } else if (water >= 45 && water < 50) {
        if (oil < 45) {
          skinState = 2;
        } else if (oil >= 45 && oil < 50) {
          skinState = 2;
        } else if (oil >= 50 && oil < 55) {
          skinState = 2;
        } else if (oil >= 55 && oil < 60) {
          skinState = 2;
        } else if (oil >= 60) {
          skinState = 2;
        }
      } else if (water >= 50 && water < 55) {
        if (oil < 45) {
          skinState = 4;
        } else if (oil >= 45 && oil < 50) {
          skinState = 4;
        } else if (oil >= 50 && oil < 55) {
          skinState = 3;
        } else if (oil >= 55 && oil < 60) {
          skinState = 2;
        } else if (oil >= 60) {
          skinState = 2;
        }
      } else if (water >= 55 && water < 60) {
        if (oil < 45) {
          skinState = 5;
        } else if (oil >= 45 && oil < 50) {
          skinState = 4;
        } else if (oil >= 50 && oil < 55) {
          skinState = 4;
        } else if (oil >= 55 && oil < 60) {
          skinState = 3;
        } else if (oil >= 60) {
          skinState = 4;
        }
      } else if (water >= 60) {
        if (oil < 45) {
          skinState = 5;
        } else if (oil >= 45 && oil < 50) {
          skinState = 4;
        } else if (oil >= 50 && oil < 55) {
          skinState = 4;
        } else if (oil >= 55 && oil < 60) {
          skinState = 4;
        } else if (oil >= 60) {
          skinState = 6;
        }
      }

      skinState = this.skin;

      if (this.data.languageOpt === 1) {
        // 根据状态返回图片
        if (skinState === 1) {
          this.skinSrc = "../static/newreport/phone_report1.jpg";
        } else if (skinState === 2) {
          this.skinSrc = "../static/newreport/phone_report2.jpg";
        } else if (skinState === 3) {
          this.skinSrc = "../static/newreport/phone_report3.jpg";
        } else if (skinState === 4) {
          this.skinSrc = "../static/newreport/phone_report4.jpg";
        } else if (skinState === 5) {
          this.skinSrc = "../static/newreport/phone_report5.jpg";
        } else if (skinState === 6) {
          this.skinSrc = "../static/newreport/phone_report6.jpg";
        }
      }

      if (this.data.languageOpt === 2) {
        // 根据状态返回图片
        if (skinState === 1) {
          this.skinSrc = "../static/newreport/tranditional/phone_report1.jpg";
        } else if (skinState === 2) {
          this.skinSrc = "../static/newreport/tranditional/phone_report2.jpg";
        } else if (skinState === 3) {
          this.skinSrc = "../static/newreport/tranditional/phone_report3.jpg";
        } else if (skinState === 4) {
          this.skinSrc = "../static/newreport/tranditional/phone_report4.jpg";
        } else if (skinState === 5) {
          this.skinSrc = "../static/newreport/tranditional/phone_report5.jpg";
        } else if (skinState === 6) {
          this.skinSrc = "../static/newreport/tranditional/phone_report6.jpg";
        }
      }

      if (this.data.languageOpt === 3) {
        // 根据状态返回图片
        if (skinState === 1) {
          this.skinSrc = "../static/newreport/english/phone_report1.jpg";
        } else if (skinState === 2) {
          this.skinSrc = "../static/newreport/english/phone_report2.jpg";
        } else if (skinState === 3) {
          this.skinSrc = "../static/newreport/english/phone_report3.jpg";
        } else if (skinState === 4) {
          this.skinSrc = "../static/newreport/english/phone_report4.jpg";
        } else if (skinState === 5) {
          this.skinSrc = "../static/newreport/english/phone_report5.jpg";
        } else if (skinState === 6) {
          this.skinSrc = "../static/newreport/english/phone_report6.jpg";
        }
      }
    },
    // 肤色分析
    async skinColor() {
      this.skinColorArray = [
        {
          title: "透白",
          colorStyle: "skin-color-block skin-color-level1",
          nameStyle: "skin-color-text",
          state: 0,
        },
        {
          title: "白皙",
          colorStyle: "skin-color-block skin-color-level2",
          nameStyle: "skin-color-text",
          state: 0,
        },
        {
          title: "自然",
          colorStyle: "skin-color-block skin-color-level3",
          nameStyle: "skin-color-text",
          state: 0,
        },
        {
          title: "小麦",
          colorStyle: "skin-color-block skin-color-level4",
          nameStyle: "skin-color-text",
          state: 0,
        },
        {
          title: "暗沉",
          colorStyle: "skin-color-block skin-color-level5",
          nameStyle: "skin-color-text",
          state: 0,
        },
        {
          title: "黝黑",
          colorStyle: "skin-color-block skin-color-level6",
          nameStyle: "skin-color-text",
          state: 0,
        },
      ];
      var colour = this.data.colour - 1;
      if (colour >= 0) {
        this.skinColorArray[colour].nameStyle = "skin-color-text selected";
        this.skinColorArray[colour].state = 1;
      }
    },
    // async skinCondition () {

    // },
    // 改变星星
    async changeStar(index) {
      this.startSrc[1] = "../static/newreport/start.png";
      this.startSrc[2] = "../static/newreport/start.png";
      this.startSrc[3] = "../static/newreport/start.png";
      this.startSrc[4] = "../static/newreport/start.png";
      this.startSrc[5] = "../static/newreport/start.png";
      for (var i = 1; i <= index; i++) {
        this.startSrc[i] = "../static/newreport/fullstart.png";
      }
      this.$forceUpdate();
    },
    async getPk() {
      const response = await this.$axios.get("/Index/Report/Contrast", {
        params: {
          checkid: this.id,
          sign: this.sign,
        },
      });
      const { value, message, starname, starimage } = response.data.data;
      this.data.value = value;
      this.data.message = message;
      this.data.starname = starname;
      this.data.starimage = starimage;
      const ctxdom = document.querySelector("#pk-process");
      const ctx = ctxdom.getContext("2d");
      ctx.clearRect(0, 0, 300, 150);
      this.$nextTick(() => {
        ctx.beginPath();
        ctx.strokeStyle = "rgb(161, 215, 230)";
        ctx.lineWidth = 30;
        ctx.arc(150, 260, 230, (Math.PI * 43) / 32, (Math.PI * 53) / 32);
        ctx.stroke();
        ctx.beginPath();
        ctx.strokeStyle = "rgb(84, 204, 226)";
        ctx.arc(
          150,
          260,
          230,
          (Math.PI * 43) / 32,
          Math.PI * (43 / 32 + ((10 / 32) * Number(this.data.value)) / 100)
        );
        ctx.stroke();
      });
    },
    // 检测报告详情
    toReportDetail() {
      this.$router.push({
        path: "/Report/pifu_profes",
        query: {
          id: this.$route.query.id,
          sign: this.$route.query.sign,
        },
      });
    },
  },
  destroyed() {
    clearInterval(this.timer);
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/NewWXReport.vue